import * as React from 'react';
import { SVGProps } from 'react';

const IconTestSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M8.205 1a1 1 0 0 0-1 1v1.143a1 1 0 0 0 1 1h.565v6.286l-2.375 3.815 10.226-1.26-1.59-2.555V4.143h.564a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1h-7.39zm9.331 13.454L5.328 15.959l-3.241 5.207A1.2 1.2 0 0 0 3.105 23h17.59a1.2 1.2 0 0 0 1.019-1.834l-4.178-6.712z" />
  </svg>
);
export default IconTestSizeM;
